export class overallAssessmentDto {
  id: number;
  assessorName: string;
  assessmentCategory: string;
  assessmentStatus: string;
  assessmentDate: Date;
  nextAssessmentDueDate: Date;
  assessorTeam: string;
  impactBusinessArea: string;
  lbgImpact: boolean | null = null;
  rfbImpact: boolean | null = null;
  lbcmImpact: boolean | null = null;
  assessmentFindings: string;
  reviewerComments: string;
  actionDetails: string;
  actionClosed: Date;
  assessmentUploadEvidance: string;
  complianceStatus: string;
  muteAssessmentFindingsUsers: string;
  muteReviewCommentsUsers: string;
  muteActionDetailsUsers: string;
  muteActionClosureUsers: string;
  summaryDetailsId: number;
  rulebookRuleID: string;
  reviewDate: Date;
  reviewerName: string;
  reviewStatus: string;
  actionType: string;
  actionOwner: string;
  actionDueDate: Date;
  actionClosureSupportingRationale: string;
  isActionRequired: boolean;
  // assessmentLastEdited!: string;
  // reviewLastEdited!: string;
  // actionDetailsLastEdited!: string;

  constructor(
    id: number,
    assessorName: string,
    assessmentCategory: string,
    assessmentStatus: string,
    assessmentDate: Date,
    nextAssessmentDueDate: Date,
    assessorTeam: string,
    impactBusinessArea: string,
    lbgImpact: boolean | null=null,
    rfbImpact: boolean | null=null,
    lbcmImpact: boolean  | null=null,
    assessmentFindings: string,
    reviewerComments: string,
    actionDetails: string,
    actionClosed: Date,
    assessmentUploadEvidance: string,
    ComplianceStatus: string,
    muteAssessmentFindingsUsers: string,
    muteReviewCommentsUsers: string,
    muteActionDetailsUsers: string,
    muteActionClosureUsers: string,
    summaryDetailsId: number,
    rulebookRuleID: string,
    reviewDate: Date,
    reviewerName: string,
    reviewStatus: string,
    actionType: string,
    actionOwner: string,
    actionDueDate: Date,
    actionClosureSupportingRationale: string,
    isActionRequired: boolean
  ) {
    this.id = id;
    this.assessorName = assessorName;
    this.assessmentCategory = assessmentCategory;
    this.assessmentStatus = assessmentStatus;
    this.assessmentDate = assessmentDate;
    this.nextAssessmentDueDate = nextAssessmentDueDate;
    this.assessorTeam = assessorTeam;
    this.impactBusinessArea = impactBusinessArea;
    this.lbgImpact = lbgImpact;
    this.rfbImpact = rfbImpact;
    this.lbcmImpact = lbcmImpact;
    this.assessmentFindings = assessmentFindings;
    this.reviewerComments = reviewerComments;
    this.actionDetails = actionDetails;
    this.actionClosed = actionClosed;
    this.assessmentUploadEvidance = assessmentUploadEvidance;
    this.complianceStatus = ComplianceStatus;
    this.muteAssessmentFindingsUsers = muteAssessmentFindingsUsers;
    this.muteReviewCommentsUsers = muteReviewCommentsUsers;
    this.muteActionDetailsUsers = muteActionDetailsUsers;
    this.muteActionClosureUsers = muteActionClosureUsers;
    this.summaryDetailsId = summaryDetailsId;
    this.rulebookRuleID = rulebookRuleID;
    this.reviewDate = reviewDate;
    this.reviewerName = reviewerName;
    this.reviewStatus = reviewStatus;
    this.actionType = actionType;
    this.actionOwner = actionOwner;
    this.actionDueDate = actionDueDate;
    this.actionClosureSupportingRationale = actionClosureSupportingRationale;
    this.isActionRequired = isActionRequired;
  }
}
export class SelfAssessmentCkDataSaveT3Dto {
  ckData: string = '';
  ckName: string = '';
  summaryDetailsId: number = 0;
  id: number = 0;
  userName: string = '';
  constructor(
    ckData: string,
    ckName: string,
    summaryDetailsId: number,
    id: number,
    userName: string
  ) {
    this.ckData = ckData;
    this.ckName = ckName;
    this.summaryDetailsId = summaryDetailsId;
    this.id = id;
    this.userName = userName;
  }
}

export class overallAssessmentVersionDto{
  id: number;
  overallAssessmentId:number;
  assessorName: string;
  assessmentCategory: string;
  assessmentStatus: string;
  assessmentDate: Date;
  nextAssessmentDueDate: Date;
  assessorTeam: string;
  impactBusinessArea: string;
  lbgImpact: boolean;
  rfbImpact: boolean;
  lbcmImpact: boolean;
  assessmentFindings: string;
  reviewerComments: string;
  actionDetails: string;
  actionClosed: Date;
  assessmentUploadEvidance: string;
  complianceStatus: string;
  muteAssessmentFindingsUsers: string;
  muteReviewCommentsUsers: string;
  muteActionDetailsUsers: string;
  muteActionClosureUsers: string;
  summaryDetailsId: number;
  rulebookRuleID: string;
  reviewDate: Date;
  reviewerName: string;
  reviewStatus: string;
  actionType: string;
  actionOwner: string;
  actionDueDate: Date;
  actionClosureSupportingRationale: string;
  isActionRequired: boolean;
  versionNumber:number;
  userId:string;

  constructor(
    id: number,
    overallAssessmentId:number,
    assessorName: string,
    assessmentCategory: string,
    assessmentStatus: string,
    assessmentDate: Date,
    nextAssessmentDueDate: Date,
    assessorTeam: string,
    impactBusinessArea: string,
    lbgImpact: boolean,
    rfbImpact: boolean,
    lbcmImpact: boolean,
    assessmentFindings: string,
    reviewerComments: string,
    actionDetails: string,
    actionClosed: Date,
    assessmentUploadEvidance: string,
    ComplianceStatus: string,
    muteAssessmentFindingsUsers: string,
    muteReviewCommentsUsers: string,
    muteActionDetailsUsers: string,
    muteActionClosureUsers: string,
    summaryDetailsId: number,
    rulebookRuleID: string,
    reviewDate: Date,
    reviewerName: string,
    reviewStatus: string,
    actionType: string,
    actionOwner: string,
    actionDueDate: Date,
    actionClosureSupportingRationale: string,
    isActionRequired: boolean,
    versionNumber:number,
    userId:string
  ) {
    this.id = id;
    this.overallAssessmentId = overallAssessmentId;
    this.assessorName = assessorName;
    this.assessmentCategory = assessmentCategory;
    this.assessmentStatus = assessmentStatus;
    this.assessmentDate = assessmentDate;
    this.nextAssessmentDueDate = nextAssessmentDueDate;
    this.assessorTeam = assessorTeam;
    this.impactBusinessArea = impactBusinessArea;
    this.lbgImpact = lbgImpact;
    this.rfbImpact = rfbImpact;
    this.lbcmImpact = lbcmImpact;
    this.assessmentFindings = assessmentFindings;
    this.reviewerComments = reviewerComments;
    this.actionDetails = actionDetails;
    this.actionClosed = actionClosed;
    this.assessmentUploadEvidance = assessmentUploadEvidance;
    this.complianceStatus = ComplianceStatus;
    this.muteAssessmentFindingsUsers = muteAssessmentFindingsUsers;
    this.muteReviewCommentsUsers = muteReviewCommentsUsers;
    this.muteActionDetailsUsers = muteActionDetailsUsers;
    this.muteActionClosureUsers = muteActionClosureUsers;
    this.summaryDetailsId = summaryDetailsId;
    this.rulebookRuleID = rulebookRuleID;
    this.reviewDate = reviewDate;
    this.reviewerName = reviewerName;
    this.reviewStatus = reviewStatus;
    this.actionType = actionType;
    this.actionOwner = actionOwner;
    this.actionDueDate = actionDueDate;
    this.actionClosureSupportingRationale = actionClosureSupportingRationale;
    this.isActionRequired = isActionRequired;
    this.versionNumber = versionNumber;
    this.userId = userId;
  }
}
